import React from 'react';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';

import DeviceVideo from 'components/DeviceVideo/DeviceVideo';

import { StyledTypography } from '../../styles/Typography';

import { StyledIcon } from './styles/List';

const TOPICS = ['TOPIC_1', 'TOPIC_2', 'TOPIC_3'];

function SectionCustomCovarage() {
  return (
    <Grid
      row
      spacingHorizontal={{ xs: '6x', md: '12x', lg: '14x' }}
      spacingVertical={{ xs: '12x', md: '20x', lg: '28x' }}
      alignItems={{ lg: 'center' }}
    >
      <Grid
        col={{ xs: 12, lg: 4 }}
        order={{ sm: 2, lg: 1, xl: 1 }}
        offset={{ lg: 1 }}
      >
        <Grid
          row
          justify="center"
          spacing="0"
        >
          <Grid col={{ md: 8, lg: 12 }}>
            <StyledTypography
              intlKey="INSURANCE.CUSTOM_COVARAGE.TITLE"
              variant="title"
              gutterBottom={{ xs: 1, md: 2, lg: 1.5 }}
            />
          </Grid>
        </Grid>
        <ul>
          {TOPICS.map(item => (
            <Box
              tag="li"
              paddingBottom="4x"
              display="flex"
              key={`topic-coverage-${item}`}
            >
              <StyledIcon name="arrow-down-right" />
              <StyledTypography
                intlKey={`INSURANCE.CUSTOM_COVARAGE.${item}`}
                tag="p"
                variant="subtitle"
                gutterBottom={{ xs: 2, md: 0 }}
              />
            </Box>
          ))}
        </ul>
      </Grid>

      <Grid
        col={{ xs: 12, lg: 5 }}
        order={{ sm: 1, lg: 2, xl: 2 }}
        spacingBottom={{ sm: '8x', lg: '0' }}
        offset={{ lg: 1 }}
      >
        <DeviceVideo
          videoId="cDqEZBjqFcA"
          deviceType="dark"
          hasDeviceOnMobile
        />
      </Grid>
    </Grid>
  );
}

export default React.memo(SectionCustomCovarage);
